import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          
        }
    }

    init() {
        // this.checkForm($("#don"));

        $('.don-wrapper .montant-choicies .choice-item').click(function () {
            $('.don-wrapper .montant-choicies .choice-item').removeClass('active');
            $(this).addClass('active');
            $(this)
                .parents('.don-wrapper')
                .find('#montant_libre')
                .val($(this).attr('data-montant'));
        });

        $('.don-wrapper #montant_libre').change(function () {
            $(this)
                .parents('.don-wrapper')
                .find('.montant-choicies .choice-item')
                .removeClass('active');
        });

    }

    checkForm(form) {
        var $ = jQuery;
        var $msg_error = 'Ce champ est obligatoire';
        var $msg_error_email =
        'Saisir une adresse email valide (ex: email@exemple.com)';
        var $msg_error_nombre =
        'Saisir un nombre valide';
        var $msg_error_extension =
        'Types de fichiers autorisés .pdf, .jpg, .jpeg, .png, .docx, .doc, .odt';
        var $msg_error_filesize =
        'Fichier trop volumineux, la taille maximale autorisée est de 5Mo';
        var $msg_error_password =
        'Le mot de passe doit être identique';

        $.validator.addMethod(
            'filesize',
            function (value, element, param) {
                return this.optional(element) || element.files[0].size <= param;
            },
            $msg_error_filesize
        );

        $(form).validate({
            ignore: [],
            lang: 'fr',
            errorElement: 'div',
            errorPlacement: function (error, element) {
                var placement = $(element).data('error');
                if (placement) {
                $(placement).append(error);
                } else {
                error.insertAfter(element);
                }
            },
        });
        const required = document.querySelectorAll(`[data-required]`);

        const rules = [];
        required.forEach(function (element) {
            if (!$(element).parents('.is-hidden').length) {
                $(element).rules('add', {
                required: true,
                messages: { required: $msg_error },
                });
                if ($(element).attr('type') == 'email') {
                $(element).rules('add', {
                    email: true,
                    messages: { email: $msg_error_email },
                });
                } else if ($(element).attr('type') == 'file') {
                $(element).rules('add', {
                    extension: 'jpeg|jpg|png|pdf|docx|doc|odt',
                    filesize: 5242880,
                    messages: { extension: $msg_error_extension },
                });
                } else if ($(element).attr('type') == 'number') {
                $(element).rules('add', {
                    number: true,
                    messages: { number: $msg_error_nombre },
                });
                } else if ($(element).attr('type') == 'password' && $(element).attr('id') == 'confirm_password') {
                $(element).rules('add', {
                    equalTo: "#password",
                    messages: { equalTo: $msg_error_password },
                });
                }
            }
        });

        const files = this.$('file');
        files.forEach(function (element) {
        if ($(element).attr('type') == 'file') {
            $(element).rules('add', {
            extension: 'jpeg|jpg|png|pdf|docx|doc|odt',
            filesize: 5242880,
            messages: { extension: $msg_error_extension },
            });
        }
        });

        const requiredWith = this.$('requiredWith');
        requiredWith.forEach(function (element) {
            if (!$(element).parents('.is-hidden').length) {
                $(element).rules('add', {
                required: function (element) {
                    const linkedInput = $(element).data('required_with');
                    return $(`${linkedInput}`).is(':checked');
                },
                messages: { required: $msg_error },
                });
            }
        });
    }
}


